export default {
  organization: typeof window !== "undefined" ? getItemStorage("t-org") || null : null,
  organizationEdit: {},
  organizations: null,
  segments: null,
  identificatorCustom: null,
  exportRange: null
};

function getItemStorage(item) {
  try {
    return JSON.parse(localStorage.getItem(item));
  } catch (error) {
    return null;
  }
}

export function getOrganizationCreateDefaultState() {
  return {
    logo: "",
    file_extension: null,
    name: "",
    primary_language: "pt_BR",
    primary_time_offset: -3,
    identificator: { name: "email", type: null },
    segment: null,
    sub_segment: null,
    website: "",
    identification_number: "",
    users_admin_email: [],
    billing_cycle: 30,
    due_date: 1,
    contracted_credits: null,
    contract_expiration: null,
    cs_uuid: null
  };
}

export function getIdentificatorCustomDefaultState() {
  return {
    type: 1,
    name: ""
  };
}
